import React from 'react';
import PropTypes from 'prop-types';
import CancelledAtFilter from 'components/form/filters/CancelledAtFilter';
import CategoryIdFilter from 'components/form/filters/CategoryIdFilter';
import CreatedAtFilter from 'components/form/filters/CreatedAtFilter';
import DestinationArrivalDateFilter from 'components/form/filters/DestinationArrivalDateFilter';
import DestinationDepartureDateFilter from 'components/form/filters/DestinationDepartureDateFilter';
import FunnelIdFilter from 'components/form/filters/FunnelIdFilter';
import IntervalFilter from 'components/form/filters/IntervalFilter';
import MultiProviderIdFilter from 'components/form/filters/MultiProviderIdFilter';
import MultiResellerIdFilter from 'components/form/filters/MultiResellerIdFilter';
import PaymentStatusFilter from 'components/form/filters/PaymentStatusFilter';
import ProductIdFilter from 'components/form/filters/ProductIdFilter';
import ReservationStatusFilter from 'components/form/filters/ReservationStatusFilter';
import ResourceFilter from 'components/list/Filters/ResourceFilter';
import SelectFieldMultiSelect from 'components/input/SelectFieldMultiSelect/SelectFieldMultiSelect';
import SubCategoryIdFilter from 'components/form/filters/SubCategoryIdFilter';
import TestBookingFilter from 'components/form/filters/TestBookingFilter';
import authHelper from 'helpers/auth';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';

const BookingsFilters = (props, context) => {
    const {
        config: {
            currency: {
                supported,
            },
        },
    } = context;

    const currencyChoices = supported.map(function (currency) {
        return {
            id: currency,
            name: currency,
        };
    });

    const CurrenciesFilter = <SelectFieldMultiSelect
        choices={ currencyChoices }
        floatingLabelFixed={ true }
        fullWidth={ true }
        label='filters.components.currencies.label'
        source='currencies'
    />;

    const filters = {
        basic: {
            interval: {
                component: IntervalFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.equals,
                    ],
                },
            },
            currencies: {
                component: CurrenciesFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            reservation_status: {
                component: ReservationStatusFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            created_at: {
                component: CreatedAtFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
        },
        advanced: {
            destination_arrival_date: {
                component: DestinationArrivalDateFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            destination_departure_date: {
                component: DestinationDepartureDateFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.between,
                    ],
                },
            },
            category_id: {
                component: CategoryIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
            subcategory_id: {
                component: SubCategoryIdFilter,
                matchTypes: {
                    values: [
                        filterMatchTypes.matchOneOf,
                    ],
                },
            },
        },
    };

    if (authHelper.isAdmin()) {
        filters.advanced.reseller_id = {
            component: MultiResellerIdFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.matchOneOf,
                ],
            },
        };

        filters.advanced.provider_id = {
            component: MultiProviderIdFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.matchOneOf,
                ],
            },
        };
    }

    if (!authHelper.isProvider()) {
        filters.advanced.is_test_order = {
            component: TestBookingFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.equals,
                ],
            },
        };

        filters.advanced.payment_status = {
            component: PaymentStatusFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.matchOneOf,
                ],
            },
        };

        filters.advanced.cancelled_at = {
            component: CancelledAtFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.between,
                ],
            },
        };

        filters.advanced.funnel_id = {
            component: FunnelIdFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.equals,
                ],
            },
        };

        filters.advanced.product_id = {
            component: ProductIdFilter,
            matchTypes: {
                values: [
                    filterMatchTypes.matchOneOf,
                ],
            },
        };
    }

    return <ResourceFilter
        { ...props }
        filters={ filters }
    />;
};

BookingsFilters.contextTypes = {
    config: PropTypes.object,
};

BookingsFilters.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string,
};

export default BookingsFilters;



// WEBPACK FOOTER //
// ./src/pages/bookingStats/list/BookingStatsListFilters.js